import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('calvi-fishing-lang');
    if (saved && ['fr', 'en', 'it'].includes(saved)) {
      return saved;
    }
    const browserLang = navigator.language.split('-')[0];
    if (['fr', 'en', 'it'].includes(browserLang)) {
      return browserLang;
    }
    return 'fr';
  });

  const changeLanguage = useCallback((lang) => {
    if (['fr', 'en', 'it'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('calvi-fishing-lang', lang);
    }
  }, []);

  const t = useCallback((path) => {
    const keys = path.split('.');
    let value = translations[language];
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        return path;
      }
    }
    return value;
  }, [language]);

  const getLocalizedField = useCallback((obj, fieldBase) => {
    if (!obj) return '';
    const field = `${fieldBase}_${language}`;
    return obj[field] || obj[`${fieldBase}_fr`] || obj[fieldBase] || '';
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
};
